import { NgModule } from '@angular/core';

import { UiSwitchComponent } from './ui-switch.component';

@NgModule({
    declarations: [UiSwitchComponent],
    exports: [UiSwitchComponent]
})
export class UiSwitchModule {
}


// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/node_modules/ngx-ui-switch/src/index.ts